/* eslint-disable no-undef */
import { RestService } from '../common/rest-service';

export class AuthService extends RestService {
	constructor() {
		super();

		this.login = this.login.bind(this);
		this.logout = this.logout.bind(this);
		this.changePassword = this.changePassword.bind(this);
		this.resetPassword = this.resetPassword.bind(this);
		this.resetPasswordConfirmation = this.resetPasswordConfirmation.bind(this);
	}

	/**
      Função para realizar o login da pessoa profissional
  
      @param {object} requestBody - Objeto com os dados para realizar o login
  
      @returns {promise} Usuário logado
    */
	async login(requestBody) {
		return await this.post('/lacreiid/auth/login/professional/', requestBody);
	}

	async infoUser(token) {
		const baseUrl = `${process.env.GATSBY_PUBLIC_API_BASE_URL}/v1/lacreisaude/user/`;
		const response = await fetch(baseUrl, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
		});

		return await response.json();
	}

	async getTokenUser(email, password) {
		const baseUrl = `${process.env.GATSBY_PUBLIC_API_BASE_URL}/v1/lacreiid/auth/login/professional/`;

		const response = await fetch(baseUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				email: email,
				password: password,
			}),
		});

		return await response.json();
	}
	/**
      Função para ter acesso a uma lista de logout da pessoa profissional
    */
	async getLogout() {
		return await this.get('/lacreiid/auth/logout/');
	}

	/**
      Função para realizar o logout da pessoa profissional
    */
	async logout() {
		return await this.post('/lacreiid/auth/logout/');
	}

	/**
      Função para realizar mudança da senha da pessoa profissional

      @param {object} requestBody - Objeto com a nova senha
  
      @returns {promise} Objeto com as informações da senha nova
    */
	async changePassword(requestBody) {
		return await this.post('/lacreiid/auth/password/change/', requestBody);
	}

	/**
      Função para realizar reset da senha da pessoa profissional caso a senha seja esquecida

      @param {object} requestBody - Objeto com o email da pessoa profissional
  
      @returns {promise} Email informado
    */
	async resetPassword(requestBody) {
		return await this.post('/lacreiid/auth/password/reset/', requestBody);
	}

	/**
      Função para confirmar reset da senha da pessoa profissional

      @param {object} requestBody - Objeto com a nova senha, uid e token

      @returns {promise} Informações de confirmação  
    */
	async resetPasswordConfirmation(requestBody) {
		return await this.post('/lacreiid/auth/password/reset/confirm/', requestBody);
	}
}
